module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero3.png?4d940886";